module.exports = __webpack_public_path__ + "img/coach-avatar-serious.d49f0cae.png";